//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class OnlineResourceSpaceDisplayItem extends ItemBase {
    Name: string | null = null;
    ID: string | null = null;
    TeacherID: string | null = null;
    ReadOnly: boolean = false;
    Shared: boolean = false;
    Default: boolean = false;
    Active: boolean = false;
    FileCount: number = 0;
    FolderCount: number = 0;

    constructor(initializer?: Partial<OnlineResourceSpaceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OnlineResourceSpaceDisplayItem";
}
